<template>
  <a-modal v-model="modal" title="工厂暂存总量" width="700px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <div class="info">
      <div class="item">
        <span class="label">物料：</span>
        <span>{{ formData.rawMaterialCode }}</span>
      </div>
      <div class="item">
        <span class="label">库存总数：</span>
        <span>{{ formData.factoryTempQty }}</span>
      </div>
    </div>
    <div>
      <ls-metable
        :columns="columns"
        :data-list="dataList"
        :scroll="{y:400}"
        :loading="loading"
        :IsEdit="false"
        :needAdd="false"
        :pagination="false"
      />
    </div>
    <template #footer></template>
  </a-modal>
</template>

<script>
import { apiListFactoryTemp } from '@/api/scp/work-order-material/work-order-material'

export default {
  name: "FactoryInventoryModal",
  data() {
    return {
      loading: false,
      modal: false,
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationCode', width: 60, align: 'center' },
        { title: '仓库', dataIndex: 'factory', width: 60, align: 'center' },
        { title: '库存', dataIndex: 'factoryQty', width: 60, align: 'center' },
        { title: '单位', dataIndex: 'uom', width: 60, align: 'center' }
      ],
      dataList: [],
      formData: {}
    }
  },
  methods: {
    show(data) {
      this.formData = data;
      this.modal = true
      this.loading = false;
      this.$nextTick(() => {
        this.onSearch(data)
      })
    },
    // 表单搜索
    onSearch (data) {
      this.dataList = [];
      const params = {
        rawMaterialCode: data.rawMaterialCode,
        current: 1,
        pageSize: 999
      }
      this.loading = true;
      apiListFactoryTemp(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.dataList = res.data
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.info{
  display: flex;
  margin-bottom: 15px;
  .item{
    margin-right: 80px;
  }
  .label{
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
